// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3cR5c","productName":"Table_productName__3v3L-"};